import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { price } from '../Helpers';
import OwlCarousel from 'react-owl-carousel';
// import Box from '@mui/material/Box';
// import Tab from '@mui/material/Tab';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
// import TabPanel from '@mui/lab/TabPanel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function Home() {
  const [value, setValue] = React.useState('1');
  const [products, setProducts] = React.useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getData = async () => {
    try {
      const response = await axios.post('/product/getHomeProducts');
      const { status, product } = response.data;
      if (status) {
        setProducts(product);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <section class="categories">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <section className="full-banner">
                <div className="banner-content">
                  <h1>Welcome to Pargati Bazaar</h1>
                  <p>- All in one lively marketplace -</p>
                  <Link className="btn btn-primary" to={'/bazaar/shop'}>Shop Now</Link>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      {/* <section class="product spad">
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <div class="container">
              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <div class="section-title">
                    <h4>New product</h4>
                  </div>
                </div>
                <div class="col-lg-8 col-md-8">
                  <Box>
                    <TabList onChange={handleChange}>
                      <Tab label="All" value="1" />
                      <Tab label="Women’s" value="2" />
                      <Tab label="Men’s" value="3" />
                      <Tab label="Kid’s" value="4" />
                    </TabList>
                  </Box>
                </div>
              </div>
              <div>
                <TabPanel value="1" className="row">
                  {
                    products && products.all.map(product => (
                      <div class="col-lg-3 col-md-4 col-sm-6">
                        <div class="product__item">
                          <Link to={'/bazaar/product/' + product._id}>
                            <div class="product__item__pic set-bg" style={{ backgroundImage: `url(${product?.images?.[0]})` }} data-setbg={product?.images?.[0]}>
                            </div>
                            <div class="product__item__text">
                              <h6>{product.productName}</h6>
                              <div class="product__price"><strike>₹{product.price}</strike> ₹{price(product.price, product.discountInPercent)}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  }
                </TabPanel>
                <TabPanel value="2" className="row">
                  {
                    products && products.women.map(product => (
                      <div class="col-lg-3 col-md-4 col-sm-6">
                        <div class="product__item">
                          <Link to={'/bazaar/product/' + product._id}>
                            <div class="product__item__pic set-bg" style={{ backgroundImage: `url(${product?.images?.[0]})` }} data-setbg={product?.images?.[0]}>
                            </div>
                            <div class="product__item__text">
                              <h6>{product.productName}</h6>
                              <div class="product__price"><strike>₹{product.price}</strike> ₹{price(product.price, product.discountInPercent)}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  }
                </TabPanel>
                <TabPanel value="3" className="row">
                  {
                    products && products.men.map(product => (
                      <div class="col-lg-3 col-md-4 col-sm-6">
                        <div class="product__item">
                          <Link to={'/bazaar/product/' + product._id}>
                            <div class="product__item__pic set-bg" style={{ backgroundImage: `url(${product?.images?.[0]})` }} data-setbg={product?.images?.[0]}>
                            </div>
                            <div class="product__item__text">
                              <h6>{product.productName}</h6>
                              <div class="product__price"><strike>₹{product.price}</strike> ₹{price(product.price, product.discountInPercent)}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  }
                </TabPanel>
                <TabPanel value="4" className="row">
                  {
                    products && products.kid.map(product => (
                      <div class="col-lg-3 col-md-4 col-sm-6">
                        <div class="product__item">
                          <Link to={'/bazaar/product/' + product._id}>
                            <div class="product__item__pic set-bg" style={{ backgroundImage: `url(${product?.images?.[0]})` }} data-setbg={product?.images?.[0]}>
                            </div>
                            <div class="product__item__text">
                              <h6>{product.productName}</h6>
                              <div class="product__price"><strike>₹{product.price}</strike> ₹{price(product.price, product.discountInPercent)}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  }
                </TabPanel>
              </div>
            </div>
          </TabContext>
        </Box>
      </section> */}
      <section class="services spad">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="services__item">
                <i class="fa fa-car"></i>
                <h6>Free Shipping</h6>
                <p>For all order over Rs 5000</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="services__item">
                <i class="fa fa-money"></i>
                <h6>Money Back Guarantee</h6>
                <p>If good have Problems</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="services__item">
                <i class="fa fa-support"></i>
                <h6>Online Support 24/7</h6>
                <p>Dedicated support</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="services__item">
                <i class="fa fa-headphones"></i>
                <h6>Payment Secure</h6>
                <p>100% secure payment</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
